import { deepFreeze } from "@/utils/structure";

export const FACILITY_ADDRESSES = deepFreeze({
  JUSTSHIP: {
    label: "JustShip",
    email: "business@justship.sg",
    callCode: "SG/+65",
    mobileNo: "97611216",
    fullAddress: "18 Howard Road, Novelty BizCentre, #07-02, Singapore 369585",
    addressLine1: "18 Howard Road",
    addressLine2: "Novelty BizCentre, #07-02",
    postalCode: "369585",
    city: "Singapore",
    state: null,
    country: "SG",
  },
  RETURN_HELPER_NJ: {
    label: "Return Helper - (RHSG030)",
    email: "sea.cs@returnhelper.com",
    callCode: "US/+1",
    mobileNo: "8554377467",
    fullAddress: "18 Distribution Blvd, Edison, NJ 08817, US",
    addressLine1: "18 Distribution Blvd",
    postalCode: "08817",
    city: "Edison",
    state: "NJ",
    country: "US",
  },
  RETURN_HELPER_WA: {
    label: "Return Helper - (RHSG030)",
    email: "sea.cs@returnhelper.com",
    callCode: "US/+1",
    mobileNo: "2063555090",
    fullAddress: "1007 Industry Drive, Bldg. 33, Tukwila, WA 98188, US",
    addressLine1: "1007 Industry Drive, Bldg. 33",
    postalCode: "98188",
    city: "Tukwila",
    state: "WA",
    country: "US",
  },
});

export const RETURN_HELPER_NJ_SERVICE_CODE = "USPS-GA-NJ";
export const RETURN_HELPER_WA_SERVICE_CODE = "USPS-GA-WA";

export const PACKING_TYPES = deepFreeze({
  Need: { fragile: "", pack: "Need Packing" },
  Fragile: { fragile: "on", pack: "Need Packing" },
  No: { fragile: "", pack: "No Packing" },
});

export const SHIPPING_PROVIDERS = deepFreeze({
  FEDEX: {
    label: "FedEx",
    value: "fedex",
    trackingURL: "https://www.fedex.com/fedextrack/?action=track&tracknumbers=",
  },
  UPS: {
    label: "UPS",
    value: "ups",
    trackingURL: "https://www.ups.com/track?tracknum=",
  },
  USPS: {
    label: "USPS",
    value: "usps",
    trackingURL:
      "https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=",
  },
  ROYAL_MAIL: {
    label: "Royal Mail",
    value: "royalmail",
    trackingURL: "https://www.royalmail.com/track-your-item#/tracking-results/",
  },
  EVRI: {
    label: "Evri",
    value: "evri",
    trackingURL: "https://evri.com/track/parcel/",
  },
  BPOST: {
    label: "bpost",
    value: "bpost",

    // Alternative: https://www.bpost2.be/bpostinternational/track_trace/find.php?search=s&lng=en&trackcode=
    // trackingURL: "https://track.bpost.cloud/btr/web/#/search?lang=en&itemCode=",
    trackingURL:
      "https://track.landmarkglobal-group.com/btr/web/#/lmg/search?lang=en&itemCodes=",
  },
  LANDMARK: {
    label: "Landmark",
    value: "landmark",
    trackingURL: "https://track.landmarkglobal.com/?search=",
  },
});

// The commented statuses are from ideation / pending implementation
// and uncommented ones are being used
export const SHIPPING_STATUSES = deepFreeze({
  // The shipment object was just created
  CREATED: {
    label: "Order Created",
    value: "created",
  },

  // // The order has been placed but has not yet been confirmed.
  // PENDING: {
  //   label: "Pending",
  //   value: "pending",
  // },

  // // (Pick-up only) Waiting to be picked up by our carriers
  // PENDING_PICK_UP: {
  //   label: "Pending for Pick Up",
  //   value: "pending_pick_up",
  // },
  // // (Pick-up only) The packages have been picked up by our carriers
  // PICK_UP: {
  //   label: "Pick up",
  //   value: "pick_up",
  // },

  // // (Drop-off only) Waiting for customers to drop off the packages at our warehouse
  // PENDING_DROPPOFF: {
  //   label: "Pending for Pick Up",
  //   value: "pending_pick_up",
  // },

  // // The packages have reached our warehouse, and are waiting to be processed
  // PROCESSING: {
  //   label: "Processing",
  //   value: "processing",
  // },

  // // Something went wrong with the orders, and require actions
  // ON_HOLD: {
  //   label: "On hold",
  //   value: "on_hold",
  // },

  ARRIVED_ORIGIN_SORTING_FACILITY: {
    label: "Arrived at origin sorting facility",
    value: "arrived_origin_sorting_facility",
  },

  // The packages have been verified, and are waiting to be picked up by shipping providers
  PROCESSED: {
    label: "Processed",
    value: "processed",
  },

  // The packages are on the way to the destination country
  IN_TRANSIT: {
    label: "In transit",
    value: "in_transit",
  },

  // The packages have arrived at the destination airport
  ARRIVED_DEST_AIRPORT: {
    label: "Arrived at destination airport",
    value: "arrived_dest_airport",
  },

  // When the first leg is delivered
  ARRIVED_DEST_SORTING_FACILITY: {
    label: "Arrived at destination sorting facility",
    value: "arrived_dest_sorting_facility",
  },

  HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER: {
    label: "Handed off to last-mile delivery partner",
    value: "handed_off_to_last_mile_delivery_partner",
  },

  // The packages are on the way to the recipient's address
  OUT_FOR_DELIVERY: {
    label: "Out for delivery",
    value: "out_for_delivery",
  },

  DELAY: {
    label: "Delay",
    value: "delay",
  },

  HELD_AT_CUSTOMS: {
    label: "Held at customs",
    value: "held_at_customs",
  },

  CLEARED_CUSTOMS: {
    label: "Cleared customs",
    value: "cleared_customs",
  },

  DISPOSED: {
    label: "Disposed",
    value: "disposed",
  },

  LOST: {
    label: "Lost",
    value: "lost",
  },

  RETURNED: {
    label: "Returned",
    value: "returned",
  },

  // An unexpected event is preventing the delivery to the recipient,
  // such as holiday closure impacts,
  // or when a signature is required from someone at the recipient's address, but no one is available.
  DELIVERY_EXCEPTION: {
    label: "Delivery exception",
    value: "delivery_exception",
  },

  DELIVERED_WITH_DAMAGE: {
    label: "Delivered with damage",
    value: "delivered_with_damage",
  },

  DELIVERED: {
    label: "Delivered",
    value: "delivered",
  },

  CANCELLED: {
    label: "Cancelled",
    value: "cancelled",
  },
});

export const EXCEPTION_STATUSES = deepFreeze([
  SHIPPING_STATUSES.DELAY.value,
  SHIPPING_STATUSES.HELD_AT_CUSTOMS.value,
  SHIPPING_STATUSES.DELIVERY_EXCEPTION.value,
]);

export const IN_TRANSIT_STAGE_STATUSES = deepFreeze([
  ...EXCEPTION_STATUSES,
  SHIPPING_STATUSES.CLEARED_CUSTOMS.value,
  SHIPPING_STATUSES.IN_TRANSIT.value,
  SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT.value,
  SHIPPING_STATUSES.ARRIVED_DEST_SORTING_FACILITY.value,
  SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER.value,
  SHIPPING_STATUSES.OUT_FOR_DELIVERY.value,
]);

export const POST_TRANSIT_STAGE_STATUSES = deepFreeze([
  SHIPPING_STATUSES.LOST.value,
  SHIPPING_STATUSES.RETURNED.value,
  SHIPPING_STATUSES.DELIVERED_WITH_DAMAGE.value,
  SHIPPING_STATUSES.DISPOSED.value,
]);

export const COMPLETED_SHIPPING_STATUSES = deepFreeze([
  SHIPPING_STATUSES.DELIVERED,
  SHIPPING_STATUSES.CANCELLED,
]);

export const OPERATIONAL_STATUSES = deepFreeze([
  SHIPPING_STATUSES.CREATED.value,
  SHIPPING_STATUSES.PROCESSED.value,
  SHIPPING_STATUSES.ARRIVED_ORIGIN_SORTING_FACILITY.value,
]);

export const FINAL_LEG_ONLY_STATUSES = deepFreeze([
  ...COMPLETED_SHIPPING_STATUSES.map((status) => status.value),
  SHIPPING_STATUSES.OUT_FOR_DELIVERY.value,
]);

export const SHIPPING_STATUS_TRANSITION_ORDER = deepFreeze([
  SHIPPING_STATUSES.CREATED.value,
  SHIPPING_STATUSES.ARRIVED_ORIGIN_SORTING_FACILITY.value,
  SHIPPING_STATUSES.PROCESSED.value,
  SHIPPING_STATUSES.IN_TRANSIT.value,
  SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT.value,
  SHIPPING_STATUSES.ARRIVED_DEST_SORTING_FACILITY.value,
  SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER.value,
  SHIPPING_STATUSES.OUT_FOR_DELIVERY.value,
]);

export const TRACKING_LOCATION_TYPES = deepFreeze({
  SENDER: {
    label: "Sender",
    value: "sender",
  },
  RECIPIENT: {
    label: "Recipient",
    value: "recipient",
  },
  ORIGIN_SORTING_FACILITY: {
    label: "Origin Sorting Facility",
    value: "origin_sorting_facility",
  },
  DESTINATION_SORTING_FACILITY: {
    label: "Destination Sorting Facility",
    value: "destination_sorting_facility",
  },
});

// Ref: https://developer.fedex.com/api/en-cd/guides/api-reference.html
export const FEDEX_SHIPPING_STATUSES = deepFreeze({
  PU: {
    status: SHIPPING_STATUSES.IN_TRANSIT, // Picked up (by FedEx)
  },
  PX: {
    status: SHIPPING_STATUSES.IN_TRANSIT, // Picked up (by FedEx)
  },
  IT: {
    status: SHIPPING_STATUSES.IN_TRANSIT, // In transit
  },
  IX: {
    status: SHIPPING_STATUSES.IN_TRANSIT, // In transit
  },
  LO: {
    status: SHIPPING_STATUSES.IN_TRANSIT, // In transit
  },
  PF: {
    status: SHIPPING_STATUSES.IN_TRANSIT, // Plane in flight
  },

  PL: {
    status: SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT, // Arrived at dest airport
  },
  FD: {
    status: SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT, // At FedEx destination facility, At local FedEx facility
  },

  AR: {
    status: SHIPPING_STATUSES.ARRIVED_DEST_SORTING_FACILITY, // Arrived at FedEx hub
    validate: ({ recipientCountry = null, location = null }) => {
      // Only map an event if it is in destination country
      const { country = null } = location || {};
      if (!country || !recipientCountry) return true;

      return country === recipientCountry;
    },
  },

  OD: {
    status: SHIPPING_STATUSES.OUT_FOR_DELIVERY, // Out for delivery
  },

  DL: {
    status: SHIPPING_STATUSES.DELIVERED, // Delivered
  },

  DD: {
    status: SHIPPING_STATUSES.DELAY, // Delivery delay
  },

  DE: {
    status: SHIPPING_STATUSES.DELIVERY_EXCEPTION, // Delivery exception
  },

  SE: {
    status: SHIPPING_STATUSES.DELIVERY_EXCEPTION, // Shipment exception
  },

  CD: {
    status: SHIPPING_STATUSES.HELD_AT_CUSTOMS, // Clearance delay
  },
});

// USPS® Pub 199 Appendix G-4:USPS® Domestic Tracking Scan Events
// Ref: https://postalpro.usps.com/pub199
export const USPS_SHIPPING_STATUSES = deepFreeze({
  "03": { status: SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER }, // USPS in possession of item
  80: { status: SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER }, // Picked Up By Shipping Partner, USPS Awaiting Item
  81: { status: SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER }, // Arrived Shipping Partner Facility, USPS Awaiting Item
  AD: { status: SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER }, // USPS in possession of item
  AE: { status: SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER }, // Arrived USPS facility
  A1: { status: SHIPPING_STATUSES.HANDED_OFF_TO_LAST_MILE_DELIVERY_PARTNER }, // Arrive USPS facility

  59: { status: SHIPPING_STATUSES.OUT_FOR_DELIVERY }, // On route, out for delivery
  OF: { status: SHIPPING_STATUSES.OUT_FOR_DELIVERY }, // Out for delivery

  "01": { status: SHIPPING_STATUSES.DELIVERED },
  63: { status: SHIPPING_STATUSES.DELIVERED },
});

// Each event in UPS has 2 types of codes: "code" and "statusCode":
// 1. "code" value maps to a "Movement Scans" code
// Ref: https://developer.ups.com/api/reference/tracking/appendix?loc=en_US
// 2. "statusCode" value maps to a "Processing Details Status Code"
// Ref: https://developer.ups.com/api/reference/tracking/api-code?loc=en_US
//
// The "description" field in the event matches exactly with the description in the "Movement Scans" table.
// However, not all events' "code" is present in the "Movement Scans" table,
// such as "Delivered" (different 'code' values), exceptions and label-created events.
//
// To map an UPS event, match the "code" field with the "Movement Scans" table first;
// if not found, use the "statusCode" field to map to the "Processing Details Status Code" table.
export const UPS_MOVEMENT_STATUSES = deepFreeze({
  PU: { status: SHIPPING_STATUSES.IN_TRANSIT }, // Pickup Scan
  PT: { status: SHIPPING_STATUSES.IN_TRANSIT }, // Pickup Scan
  OR: { status: SHIPPING_STATUSES.IN_TRANSIT }, // Arrived at Facility
  EP: { status: SHIPPING_STATUSES.IN_TRANSIT }, // Export Scan

  IP: { status: SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT }, // Import Scan

  DS: { status: SHIPPING_STATUSES.ARRIVED_DEST_SORTING_FACILITY }, // Destination Scan / Processing at UPS Facility
  YP: { status: SHIPPING_STATUSES.ARRIVED_DEST_SORTING_FACILITY }, // Destination Scan

  OF: { status: SHIPPING_STATUSES.OUT_FOR_DELIVERY }, // Out for delivery

  BZ: { status: SHIPPING_STATUSES.DISPOSED }, // Shipment disposed
  18: { status: SHIPPING_STATUSES.DELAY }, // Delay due to late flight
  "1K": { status: SHIPPING_STATUSES.DELAY }, // Delay due to late flight
  B5: { status: SHIPPING_STATUSES.HELD_AT_CUSTOMS }, // UPS initiated contact with receiver or importer for clearance information
  EV: { status: SHIPPING_STATUSES.HELD_AT_CUSTOMS }, // UPS initiated contact with receiver or importer for clearance information
});

export const UPS_PROCESSING_STATUSES = deepFreeze({
  "014": { status: SHIPPING_STATUSES.CLEARED_CUSTOMS }, // Clearance Completed	/ Cleared Customs

  "011": { status: SHIPPING_STATUSES.DELIVERED }, // Delivered
});

// Unofficial list of statuses for reference,
// would be good to cross-reference with our logs
// https://parcelsapp.com/en/carriers/belgium-post -
export const BPOST_SHIPPING_DESCRIPTIONS = deepFreeze({
  "Item deposited to local postal operator": {
    // Bpost facility
    status: SHIPPING_STATUSES.IN_TRANSIT,
  },
  "Departure from office of exchange": {
    status: SHIPPING_STATUSES.IN_TRANSIT,
  },
  "Arrival in the country of destination": {
    status: SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT,
  },
  "Import procedure completed": {
    status: SHIPPING_STATUSES.ARRIVED_DEST_AIRPORT,
  },

  "Retained at customs": {
    status: SHIPPING_STATUSES.HELD_AT_CUSTOMS,
  },
  "Customs cleared": {
    status: SHIPPING_STATUSES.CLEARED_CUSTOMS,
  },

  // Bpost outbound description:
  // "Your shipment has arrived at the local carrier of the country of destination
  // and will be delivered in the coming days"
  "prepared by the postman": {
    status: SHIPPING_STATUSES.OUT_FOR_DELIVERY,
    validate: ({ recipientCountry = null, location = null }) => {
      // Only map an event if it is in destination country
      const { country = null } = location || {};
      if (!country || !recipientCountry) return false;

      return country === recipientCountry;
    },
  },

  "Item delivered": { status: SHIPPING_STATUSES.DELIVERED },
});

export const DEFAULT_STANDARD_BOX = deepFreeze({
  length: 49,
  width: 34,
  height: 30,
  boxName: "Custom Box A",
});

export const MAX_STANDARD_PACKAGE = deepFreeze({
  length: DEFAULT_STANDARD_BOX.length - 2,
  width: DEFAULT_STANDARD_BOX.width - 2,
  height: DEFAULT_STANDARD_BOX.height - 2,
});
